import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

export default function SuccessPage() {
  const [searchParams] = useSearchParams();
  const [countdown, setCountdown] = useState(10);
  const success = searchParams.get('success');

  useEffect(() => {
    if (success === 'true') {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            window.location.href = '/';
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [success]);

  if (success !== 'true') {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center px-4">
        <div className="max-w-md w-full text-center">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-close-line text-4xl text-red-600"></i>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Payment Cancelled
          </h1>
          <p className="text-lg text-gray-600 mb-8">
            Your order was cancelled. No charges were made.
          </p>
          <Link
            to="/"
            className="inline-block bg-red-600 text-white px-8 py-3 rounded-full text-lg font-semibold hover:bg-red-700 transition-all whitespace-nowrap cursor-pointer"
          >
            Return to Home
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center">
        <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12">
          <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-checkbox-circle-fill text-5xl text-green-600"></i>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Order Successful!
          </h1>
          
          <p className="text-xl text-gray-600 mb-6">
            Thank you for your purchase!
          </p>
          
          <div className="bg-green-50 rounded-xl p-6 mb-8">
            <p className="text-lg text-gray-700 mb-2">
              Your order has been confirmed and we've sent a confirmation email to your inbox.
            </p>
            <p className="text-gray-600">
              We'll process your Southern Roots Bloody Mary Mix order right away!
            </p>
          </div>

          <div className="space-y-4 mb-8">
            <div className="flex items-center justify-center space-x-3 text-gray-600">
              <i className="ri-mail-line text-xl text-green-600"></i>
              <span>Order confirmation sent to your email</span>
            </div>
            <div className="flex items-center justify-center space-x-3 text-gray-600">
              <i className="ri-truck-line text-xl text-green-600"></i>
              <span>Your order will be shipped soon</span>
            </div>
            <div className="flex items-center justify-center space-x-3 text-gray-600">
              <i className="ri-heart-line text-xl text-green-600"></i>
              <span>Supporting local communities with your purchase</span>
            </div>
          </div>

          <div className="border-t border-gray-200 pt-6">
            <p className="text-sm text-gray-500 mb-4">
              Redirecting to home in {countdown} seconds...
            </p>
            <Link
              to="/"
              className="inline-block bg-red-600 text-white px-8 py-3 rounded-full text-lg font-semibold hover:bg-red-700 transition-all whitespace-nowrap cursor-pointer"
            >
              Return to Home
            </Link>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-gray-600">
            Questions about your order?{' '}
            <a href="/#contact" className="text-red-600 hover:text-red-700 font-semibold cursor-pointer">
              Contact us
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
